import "./Slider.scss";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";

function Slider() {
  const { t } = useTranslation();

  return (
    <>
      <div className="main">
        <div >
          <Carousel>
            <Carousel.Item>
              <img className="d-block w-[100%]" src={t("img1")} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={t("img2")} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={t("img3")} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={t("img4")} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={t("img5")} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={t("img6")} alt="" />
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </>
  );
}

export default Slider;
